/* The profile's tabs, in the order the design lists them. */
export const CUSTOMER_TABS = [
  { key: "dashboard", labelKey: "dublicatedText80" },
  { key: "assetmanagement", labelKey: "dublicatedText282" },
  /*
    The Wealth Report view of this customer's Asset Management. A tab of its
    own, as it is on the customer's own band and on the partner's demo strip,
    so the three places a partner can stand all name the same pages.
  */
  { key: "wealth", labelKey: "dublicatedText306" },
  { key: "beneficiaries", labelKey: "dublicatedText82" },
  { key: "advisors", labelKey: "dublicatedText26" },
];
